import ImageLinker from './ImageLinker'

export default ImageLinker
